import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { CheckboxGetmSize, CheckboxGetmStatus } from '../../enums/checkbox-getm.types';

@Component({
    selector: 'app-checkbox-getm',
    templateUrl: './checkbox-getm.component.html',
    styleUrls: ['./checkbox-getm.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxGetmComponent),
            multi: true
        }
    ]
})
export class CheckboxGetmComponent implements ControlValueAccessor {

    @Input() size: CheckboxGetmSize = 'medium';
    @Input() status: CheckboxGetmStatus = 'default';
    @Input() disabled = false;
    @Input() label: string = '';
    @Input() name: string = '';
    @Input() value: any = true;
    @Input() color: 'primary' | 'secondary' = 'primary';
    @Output() change = new EventEmitter<boolean>();

    public internalValue = false;

    private onChange: (value: boolean) => void = () => { };
    private onTouched: () => void = () => { };

    /**
     * Genera las clases CSS para ion-checkbox basándose en size, status y color
     */
    public get checkboxClass(): string {
        const classes = [
            'checkbox-getm',
            `checkbox-getm--${this.size}`,
            `checkbox-getm--${this.color}`
        ];

        if (this.disabled) {
            classes.push('checkbox-getm--disabled');
        }

        return classes.join(' ');
    }

    /**
     * Genera las clases para el contenedor del checkbox
     */
    public get containerClass(): string {
        const classes = ['checkbox-getm-container'];

        if (this.disabled) {
            classes.push('checkbox-getm-container--disabled');
        }

        return classes.join(' ');
    }

    /**
     * Maneja el evento ionChange de ion-checkbox
     */
    public onIonChange(event: any): void {
        if (this.disabled) {
            return;
        }

        this.internalValue = event.detail.checked;
        this.onChange(this.internalValue);
        this.onTouched();
        this.change.emit(this.internalValue);
    }

    /**
     * Implementación de ControlValueAccessor
     */
    public writeValue(value: boolean): void {
        this.internalValue = !!value;
    }

    public registerOnChange(fn: (value: boolean) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
